export default __webpack_public_path__ + "static/media/shutterstock_1696299955.80143b68.webp";